import React from 'react';
import Layout from '../components/layout';

import Hero from '../components/sections/index/Hero/Hero';
import About from '../components/sections/index/About/About';

const IndexPage = () => (
  <Layout>
    <Hero />
    <About />
  </Layout>
);

export default IndexPage;
